import React from "react";
import Frame from "../../images/smk_logo.png";
import Logo from "../../images/smk_logo.jpg";

const LeftPanel = () => {
  return (
    <React.Fragment>
      <div className="d-flex justify-content-center align-items-center leftPanel-container">
        <img className="w-75" src={Frame} alt="" />
      </div>
    </React.Fragment>
  );
};

export default LeftPanel;
